import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class AlertService {
    private subject = new Subject<any>();
    private showAfterRedirect = false;

    constructor(private router: Router, private toastr: ToastrService) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.showAfterRedirect) {
                    this.showAfterRedirect = false;
                } else {
                    this.clear();
                }
            }
        });
    }

    onAlert(): Observable<any> {
        return this.subject.asObservable();
    }

    success(message: string, options: any = {}) {
        this.toastr.success( message);
   //    this.show('success', message, options);
    }

    warning(message: string, options: any = {}) {
        this.toastr.warning( message);
      //  this.show('warning', message, options);
    }

    error(message: string, options: any = {}) {
        this.toastr.error( message);
     //   this.show('error', message, options);
    }

    show(type: string, message: string, options: any) {
        if (options?.showAfterRedirect) {
            this.showAfterRedirect = options.showAfterRedirect;
        }

        this.subject.next({ type: type, message: message });
    }

    clear() {
        this.subject.next(null);
    }
}